// web/src/tutorial/catalog.ts
// 教程文档的「轻量目录」：只有 kind → slug，没有正文。
//
// 为什么单独放一份：四类教程正文合起来接近 2MB，而页面装配层（pages.ts）只需要
// 判断「另一类里有没有同 slug 的页面」来决定是否显示跨类入口。如果装配层直接
// import 四个注册表，四个入口 bundle 就都会被打进全部正文（各 2.4MB）；
// 现在正文由各入口按需 import，装配层只依赖这份几百字节的目录。
//
// `npm run verify:tutorial` 会校验本目录与真实注册表完全一致，防止两处漂移
// （注册表顺序即「上一篇 / 下一篇」顺序，这里只关心成员集合）。

import type { TutorialKind } from "./types";

const PRODUCT_SLUGS = [
  "key-ripple",
  "string-flow",
  "fret-dance",
  "beat-bloom",
  "zheng-drift",
  "harp-glide",
  "wind-rise",
] as const;

export const TUTORIAL_SLUGS: Record<TutorialKind, readonly string[]> = {
  quickstart: PRODUCT_SLUGS,
  // Rust 端软件界面的逐个参数说明页（一篇对应一个产品）
  detail: PRODUCT_SLUGS,
  advanced: PRODUCT_SLUGS,
  // 两个插件手册各有一篇 overview（通用部分），另有附赠模块 singer
  plugin: ["overview", ...PRODUCT_SLUGS],
  // Unreal 侧多一篇 common（B/C Mapping + Lip Sync 两个公共页签，排在最后，
  // 顺序与 unreal/index.ts 的注册表一致 —— 它就是页面「上一篇 / 下一篇」的顺序）
  unreal: ["overview", ...PRODUCT_SLUGS, "singer", "common"],
};

/** 该类教程里是否存在该 slug 的页面（跨类「继续学习 / 换平台」入口用） */
export function hasDoc(kind: TutorialKind, slug: string): boolean {
  return TUTORIAL_SLUGS[kind].includes(slug);
}
